import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography
} from '@material-ui/core'
import { useStyles } from './InfoCard.styles'
import { CardCategory } from './InfoCard.types'

interface InfoCardProps {
  title: string
  category: CardCategory
  actionLabel?: string
  link?: string
}
const InfoCard = ({ title, category, actionLabel, link }: InfoCardProps) => {
  const classes = useStyles()
  return (
    <Card
      className={classes.card}
      style={{
        backgroundColor: category.backgroundColor
      }}
    >
      <CardActionArea
        className={classes.cardActionArea}
        component={link ? RouterLink : 'div'}
        to={link || ''}
      >
        <CardContent className={classes.cardContent}>
          <Typography
            className={classes.category}
            style={{
              backgroundColor: category.badgeBackground,
              color: category.badgeTextColor
            }}
          >
            {category.label}
          </Typography>
          <Typography
            variant='h6'
            className={classes.title}
            style={{
              color: category.titleColor
            }}
          >
            {title}
          </Typography>
          {actionLabel && (
            <CardActions className={classes.actions}>
              <Button className={classes.actionsButton}>
                <Typography className={classes.actionText}>
                  {actionLabel}
                </Typography>
              </Button>
            </CardActions>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default InfoCard
